import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Sidebar from '../common/Sidebar/Sidebar';
import { useTranslation } from 'react-i18next';
import { getWhatIsMyBusiness } from '../../Redux/Actions/UserAction';
import { getSettingsSidebarOptions } from './sidebarOptions';

export default function BecomeASeller() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getWhatIsMyBusiness());
  }, [dispatch]);

  const getMybusiness = useSelector((state) => state.home?.getMybusiness);
  const sideBarOpt = getSettingsSidebarOptions(t, getMybusiness);

  const serviceOptions = [
    { code: 'CAR01', label: t('Spare Parts'), route: '/sp-spare-parts-business', icon: 'assets/images/service-icons/spare-parts.svg' },
    { code: 'CAR02', label: t('Garages'), route: '/sp-garages-business', icon: 'assets/images/service-icons/garage.svg' },
    { code: 'CAR03', label: t('Car Dealers'), route: '/sp-car-dealers-business', icon: 'assets/images/service-icons/car-dealer.svg' },
    { code: 'CAR04', label: t('Rent a Car'), route: '/sp-rent-car-business', icon: 'assets/images/service-icons/rent-a-car.svg' },
    { code: 'CAR06', label: t('Car Wash'), route: '/sp-car-wash-business', icon: 'assets/images/service-icons/car-wash.svg' },
    { code: 'CAR07', label: t('Car Insurance'), route: '/sp-car-insurance-business', icon: 'assets/images/service-icons/car-insurance.svg' },
    { code: 'CAR08', label: t('Driving School'), route: '/sp-driving-school-business', icon: 'assets/images/service-icons/driving-school.svg' },
    { code: 'CAR09', label: t('Car Protection'), route: '/sp-car-protection-business', icon: 'assets/images/service-icons/car-protection.svg' },
    { code: 'CAR11', label: t('Taxi'), route: '/sp-taxi-business', icon: 'assets/images/service-icons/taxi.svg' },
    { code: 'CAR12', label: t('Air Conditioning'), route: '/sp-air-conditioning-business', icon: 'assets/images/service-icons/air-conditioning.svg' },
    { code: 'CAR13', label: t('Quick Services'), route: '/sp-quick-services-business', icon: 'assets/images/service-icons/quick-services.svg' },
  ];

  return (
    <div>
      <div class="main-content-area">
        <div class="container">
          <h2 class="mb-4">{t('Settings')}</h2>

          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} showPackage={false} />
            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h5 class="mb-4">{t('Become a Seller')}</h5>
              <p class="mb-4">{t('Register your company by selecting a service category below:')}</p>
              <div class="row">
                {serviceOptions.map((service, index) => (
                  <div class="col-6 col-sm-6 col-md-4 col-lg-3 mb-4" key={index}>
                    <div class="icons-dashboard hvr-float">
                      <Link to={service.route}>
                        <div class="line-a">
                          <img
                            src={service.icon}
                            alt={service.label}
                            class="img-fluid"
                          />
                        </div>
                        <div class="line-b">{service.label}</div>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
              {/* [CF 2026-08-17] "Post a Car for Sale" removed from this screen.
                  Client: it is not a business category. Everything else here
                  registers a company and starts a subscription; selling one car
                  is something any ordinary user does from their own account, so
                  offering it alongside the twelve categories read as a
                  thirteenth kind of business. The route itself is untouched —
                  it is still reachable from "Add Car for Sale" in the menu and
                  from My Posts. */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
